import {type ChangeEvent, type KeyboardEvent, useState} from "react";
import type {Property} from "csstype";

import {Input} from "@pg-design/inputs-module";

interface IProps {
    value: number | string;
    minWidth?: Property.MinWidth;
    onSave: (value: number | string) => void;
    onCancel?: () => void;
    type: "text" | "number";
}

export const TableCellEditableInput = (props: IProps) => {
    const [value, setValue] = useState(props.value);

    const onKeyUp = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            props.onSave(value);
        }

        if (event.key === "Escape") {
            props.onCancel?.();
        }
    };

    const onBlur = () => {
        props.onSave(value);
    };

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    return (
        <Input type={props.type} autoFocus value={value} onChange={onChange} onBlur={onBlur} onKeyUp={onKeyUp} style={{minWidth: props.minWidth || "100%"}} />
    );
};
import {type ChangeEvent, type KeyboardEvent, useState} from "react";
import type {Property} from "csstype";

import {Input} from "@pg-design/inputs-module";

interface IProps {
    value: number | string;
    minWidth?: Property.MinWidth;
    onSave: (value: number | string) => void;
    onCancel?: () => void;
    type: "text" | "number";
}

export const TableCellEditableInput = (props: IProps) => {
    const [value, setValue] = useState(props.value);

    const onKeyUp = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === "Enter") {
            props.onSave(value);
        }

        if (event.key === "Escape") {
            props.onCancel?.();
        }
    };

    const onBlur = () => {
        props.onSave(value);
    };

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);
    };

    return (
        <Input type={props.type} autoFocus value={value} onChange={onChange} onBlur={onBlur} onKeyUp={onKeyUp} style={{minWidth: props.minWidth || "100%"}} />
    );
};
